let measureCtx = null;

const getMeasureCtx = () => {
  if (!measureCtx) {
    const canvas = document.createElement('canvas');
    measureCtx = canvas.getContext('2d');
  }
  return measureCtx;
};

const buildFontString = (fontSize, fontFamily, fontStyle) => {
  const style = fontStyle || 'normal';
  const weight = style.includes('bold') ? 'bold' : 'normal';
  const slant = style.includes('italic') ? 'italic' : 'normal';
  return `${slant} ${weight} ${fontSize}px ${fontFamily || 'Arial'}`;
};

// Mirrors Konva's word-wrap so the estimate matches what actually renders.
export const wrapTextLines = (text, { width, fontSize, fontFamily, fontStyle }) => {
  const ctx = getMeasureCtx();
  ctx.font = buildFontString(fontSize, fontFamily, fontStyle);

  const words = String(text ?? '').split(/\s+/).filter(Boolean);
  if (words.length === 0) return [''];

  const lines = [];
  let currentLine = words[0];

  for (let i = 1; i < words.length; i++) {
    const testLine = `${currentLine} ${words[i]}`;
    if (ctx.measureText(testLine).width <= width) {
      currentLine = testLine;
    } else {
      lines.push(currentLine);
      currentLine = words[i];
    }
  }
  lines.push(currentLine);
  return lines;
};

// Shrinks fontSize (down to minFontSize) so the wrapped text fits within
// height + a small extra allowance, instead of overflowing on top of
// neighboring elements.
export const fitTextToBox = ({
  text,
  width,
  height,
  fontSize,
  fontFamily,
  fontStyle,
  lineHeight = 1,
  minFontSize = 8,
  maxExtraLines = 1,
}) => {
  if (!width || !height || !fontSize) {
    return { fontSize, height };
  }

  const budget = height + maxExtraLines * fontSize * lineHeight;

  let fitted = fontSize;
  let lines = wrapTextLines(text, { width, fontSize: fitted, fontFamily, fontStyle });
  let requiredHeight = lines.length * fitted * lineHeight;

  while (requiredHeight > budget && fitted > minFontSize) {
    fitted -= 1;
    lines = wrapTextLines(text, { width, fontSize: fitted, fontFamily, fontStyle });
    requiredHeight = lines.length * fitted * lineHeight;
  }

  return {
    fontSize: fitted,
    height: Math.max(height, requiredHeight),
  };
};
